module.exports = __webpack_public_path__ + "img/wujinmu8.3862dbad.jpg";